export const ADMIN_ROLE = 'admin';

export const hasAdminRole = (roles: readonly string[] | null | undefined): boolean =>
  roles?.includes(ADMIN_ROLE) ?? false;
